import React from "react";
import { Select, Spin } from "antd";

interface FilterOption {
  value: string;
  label: string;
  color?: string;
}

interface FilterDropdownProps {
  label: string;
  options: FilterOption[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  width?: number;
  onSearch?: (value: string) => void;
  loading?: boolean;
  prefixIcon?: React.ReactNode;
  mode?: "multiple" | "single";
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  label,
  options,
  selectedValues,
  onChange,
  placeholder = "Select...",
  width = 200,
  onSearch,
  loading = false,
  prefixIcon,
  mode = "multiple",
}) => {
  const isMulti = mode === "multiple";

  const handleSelectChange = (val: any) => {
    if (isMulti) {
      onChange(val as string[]);
    } else {
      onChange(val ? [val as string] : []);
    }
  };

  const selectNode = (
    <Select
      className={`pt-filter-select ${prefixIcon ? "has-prefix" : ""}`}
      mode={isMulti ? "multiple" : undefined}
      allowClear
      style={{ minWidth: width || 220, width: "auto" }}
      placeholder={placeholder}
      value={isMulti ? selectedValues : selectedValues[0]}
      onChange={handleSelectChange}
      showSearch
      onSearch={onSearch}
      filterOption={
        onSearch
          ? false
          : (input, option) =>
            String(option?.label ?? "")
              .toLowerCase()
              .includes(input.toLowerCase())
      }
      notFoundContent={loading ? <Spin size="small" /> : undefined}
      options={options.map((opt) => ({
        value: opt.value,
        label: opt.label,
      }))}
      maxTagCount="responsive"
    />
  );

  return (
    <div className="pt-filter-wrapper">
      {prefixIcon && <div className="pt-filter-icon">{prefixIcon}</div>}
      {selectNode}
    </div>
  );
};

export default FilterDropdown;
